import { FlexProps } from '@chakra-ui/react';
import React from 'react';
import { BlockHeader } from 'shared';

/**
 * Пропсы для компонента хедера компонента блока
 * позиций кондитерской
 */
export type SweetShopArticlesPageMainHeaderProps = {
    name: string;
    description?: any;
    imageSrc: string;
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const SweetShopArticlesPageMainHeader: React.FC<SweetShopArticlesPageMainHeaderProps> = ({
    name,
    description,
    imageSrc,
}) => (
    <BlockHeader
        title={name}
        description={description || []}
        imageSrc={imageSrc}
    />
);
